import React from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import "../styles/Dashboard.css";

const ClienteModal = ({
  isOpen,
  onClose,
  onSave,
  cliente,
  setClienteData,
  handleFileChange,
  previewFiles,
  handleRemovePreviewFile,
}) => {
  if (!isOpen) return null;

  const {
    nome,
    indirizzo,
    telefono,
    telefono_secondario,
    email,
    codice_fiscale,
    referente,
    tipo_impianto,
    data_installazione,
    marca_modello,
    numero_matricola,
    numero_contratto,
    stato_garanzia,
    tipo_manutenzione,
    data_ultimo_intervento,
    scadenza_prossima_manutenzione,
    schemi_disegni,
    numero_zone,
    descrizione_configurazione,
    password_codici,
    note_interventi_futuri,
    foto_impianto,
    documenti_firmati,
    verbale_collaudo,
    manualistica,
    certificazioni,
    storico_interventi,
    problemi_ricorrenti,
    materiali_sostituiti,
    note_generali,
    invio_email_scadenza,
  } = cliente;

  const toPreviewList = (field) => {
    const value = previewFiles?.[field];
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  };

  const renderFilePreview = (field, isImage = false) => {
    const previews = toPreviewList(field);
    if (previews.length === 0) return null;

    return (
      <div className="preview-section" style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "8px" }}>
        {previews.map((preview, index) => {
          const url = typeof preview === "string" ? preview : preview?.url;
          const name = typeof preview === "string"
            ? preview.split("/").pop()
            : preview?.name || preview?.url || `Allegato ${index + 1}`;
          const type = preview?.type || "";
          const looksImage = isImage || type.startsWith("image/") || /\.(jpg|jpeg|png|webp|gif)$/i.test(name || "");

          return (
            <div
              key={`${field}-${index}-${name}`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "8px",
                background: "#f8f9fa",
              }}
            >
              {looksImage && url ? (
                <img src={url} alt={name || "Allegato"} style={{ maxWidth: "120px", maxHeight: "90px", objectFit: "contain" }} />
              ) : url ? (
                <a href={url} target="_blank" rel="noopener noreferrer">
                  Apri file: {name}
                </a>
              ) : (
                <span>File selezionato: {name}</span>
              )}

              {!url && <span>{name}</span>}

              <button
                type="button"
                onClick={() => handleRemovePreviewFile(field, index)}
                className="remove-btn"
              >
                Cancella
              </button>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-content large-modal">
          <h3>{cliente.id ? "Modifica Cliente" : "Nuovo Cliente"}</h3>

          {/* Anagrafica Cliente */}
          <div className="modal-section">
            <h4>🧑‍💻 Anagrafica Cliente</h4>
            <label>Nome e Cognome / Ragione Sociale:</label>
            <input
              type="text"
              value={nome || ""}
              onChange={(e) => setClienteData({ ...cliente, nome: e.target.value })}
            />

            <label>Indirizzo (Via, Numero Civico, CAP, Città, Provincia):</label>
            <input
              type="text"
              value={indirizzo || ""}
              onChange={(e) => setClienteData({ ...cliente, indirizzo: e.target.value })}
            />

            <label>Telefono principale:</label>
            <input
              type="text"
              value={telefono || ""}
              onChange={(e) => setClienteData({ ...cliente, telefono: e.target.value })}
            />

            <label>Telefono secondario:</label>
            <input
              type="text"
              value={telefono_secondario || ""}
              onChange={(e) => setClienteData({ ...cliente, telefono_secondario: e.target.value })}
            />

            <label>Email:</label>
            <input
              type="email"
              value={email || ""}
              onChange={(e) => setClienteData({ ...cliente, email: e.target.value })}
            />

            <label>Codice Fiscale o Partita IVA:</label>
            <input
              type="text"
              value={codice_fiscale || ""}
              onChange={(e) => setClienteData({ ...cliente, codice_fiscale: e.target.value })}
            />

            <label>Referente interno (se azienda):</label>
            <input
              type="text"
              value={referente || ""}
              onChange={(e) => setClienteData({ ...cliente, referente: e.target.value })}
            />
          </div>

          {/* Dati Impianto */}
          <div className="modal-section">
            <h4>🏠 Dati Impianto</h4>
            <label>Tipo impianto:</label>
            <select
              value={tipo_impianto || ""}
              onChange={(e) => setClienteData({ ...cliente, tipo_impianto: e.target.value })}
            >
              <option value="">Seleziona...</option>
              <option value="antintrusione">Antintrusione</option>
              <option value="videosorveglianza">Videosorveglianza</option>
              <option value="antincendio">Antincendio</option>
              <option value="controllo_accessi">Controllo Accessi</option>
              <option value="rete_dati">Rete Dati</option>
            </select>

            <label>Data di installazione:</label>
            <input
            type="date"
            value={data_installazione || ""}
            onChange={(e) => {
            const selectedDate = e.target.value; // Formato YYYY-MM-DD
            setClienteData({ ...cliente, data_installazione: selectedDate });
            }}
            />

            <label>Marca e Modello dei dispositivi principali:</label>
            <input
              type="text"
              value={marca_modello || ""}
              onChange={(e) => setClienteData({ ...cliente, marca_modello: e.target.value })}
            />

            <label>Numero di matricola / serie:</label>
            <input
              type="text"
              value={numero_matricola || ""}
              onChange={(e) => setClienteData({ ...cliente, numero_matricola: e.target.value })}
            />

            <label>Numero contratto (se presente):</label>
            <input
              type="text"
              value={numero_contratto || ""}
              onChange={(e) => setClienteData({ ...cliente, numero_contratto: e.target.value })}
            />

            <label>Stato Garanzia:</label>
            <select
              value={stato_garanzia || ""}
              onChange={(e) => setClienteData({ ...cliente, stato_garanzia: e.target.value })}
            >
              <option value="">Seleziona...</option>
              <option value="attiva">Attiva</option>
              <option value="scaduta">Scaduta</option>
            </select>

            <label>Tipo manutenzione:</label>
            <select
              value={tipo_manutenzione || ""}
              onChange={(e) => setClienteData({ ...cliente, tipo_manutenzione: e.target.value })}
            >
              <option value="">Seleziona...</option>
              <option value="ordinaria">Ordinaria</option>
              <option value="straordinaria">Straordinaria</option>
            </select>

            <label>Data ultimo intervento eseguito:</label>
            <input
              type="date"
              value={data_ultimo_intervento || ""}
              onChange={(e) => setClienteData({ ...cliente, data_ultimo_intervento: e.target.value })}
            />

            <label>Scadenza prossima manutenzione:</label>
            <input
              type="date"
              value={scadenza_prossima_manutenzione || ""}
              onChange={(e) => setClienteData({ ...cliente, scadenza_prossima_manutenzione: e.target.value })}
            />
          </div>

          {/* Configurazione Tecnica */}
          <div className="modal-section">
            <h4>📝 Configurazione Tecnica</h4>
            <label>Schemi e disegni tecnici allegati:</label>
            <input
              type="text"
              value={schemi_disegni || ""}
              onChange={(e) => setClienteData({ ...cliente, schemi_disegni: e.target.value })}
            />

            <label>Numero zone installate (se antifurto/antincendio):</label>
            <input
              type="number"
              value={numero_zone || ""}
              onChange={(e) => setClienteData({ ...cliente, numero_zone: e.target.value })}
            />

            <label>Descrizione configurazione:</label>
            <textarea
              value={descrizione_configurazione || ""}
              onChange={(e) => setClienteData({ ...cliente, descrizione_configurazione: e.target.value })}
              rows="3"
            />

            <label>Password e codici amministrativi (protetti):</label>
            <input
              type="password"
              value={password_codici || ""}
              onChange={(e) => setClienteData({ ...cliente, password_codici: e.target.value })}
            />

            <label>Note specifiche per interventi futuri:</label>
            <textarea
              value={note_interventi_futuri || ""}
              onChange={(e) => setClienteData({ ...cliente, note_interventi_futuri: e.target.value })}
              rows="3"
            />
          </div>

          {/* Allegati e Documenti */}
          <div className="modal-section">
            <h4>📂 Allegati e Documenti</h4>
            <label>Foto impianto installato:</label>
            <input type="file" accept="image/*" multiple onChange={(e) => handleFileChange(e, "foto_impianto")} />
            {renderFilePreview("foto_impianto", true)}

            <label>Documenti firmati:</label>
            <input type="file" accept=".pdf,image/*" multiple onChange={(e) => handleFileChange(e, "documenti_firmati")} />
            {renderFilePreview("documenti_firmati")}

            <label>Verbale di collaudo:</label>
            <input type="file" accept=".pdf,image/*" multiple onChange={(e) => handleFileChange(e, "verbale_collaudo")} />
            {renderFilePreview("verbale_collaudo")}

            <label>Manualistica tecnica impianto:</label>
            <input type="file" accept=".pdf,image/*" multiple onChange={(e) => handleFileChange(e, "manualistica")} />
            {renderFilePreview("manualistica")}

            <label>Certificazioni e Dichiarazioni di conformità:</label>
            <input type="file" accept=".pdf,image/*" multiple onChange={(e) => handleFileChange(e, "certificazioni")} />
            {renderFilePreview("certificazioni")}
          </div>

          {/* Storico Interventi */}
          <div className="modal-section">
            <h4>🔔 Storico Interventi</h4>
            <label>Elenco interventi precedenti:</label>
            <textarea
              value={storico_interventi || ""}
              onChange={(e) => setClienteData({ ...cliente, storico_interventi: e.target.value })}
              rows="3"
            />

            <label>Problemi ricorrenti / segnalazioni particolari:</label>
            <textarea
              value={problemi_ricorrenti || ""}
              onChange={(e) => setClienteData({ ...cliente, problemi_ricorrenti: e.target.value })}
              rows="3"
            />

            <label>Elenco materiali sostituiti:</label>
            <textarea
              value={materiali_sostituiti || ""}
              onChange={(e) => setClienteData({ ...cliente, materiali_sostituiti: e.target.value })}
              rows="3"
            />
          </div>

          {/* Note Generali */}
          <div className="modal-section">
            <h4>💡 Note Generali</h4>
            <label>Note aggiuntive:</label>
            <textarea
              value={note_generali || ""}
              onChange={(e) => setClienteData({ ...cliente, note_generali: e.target.value })}
              rows="3"
            />
          </div>

          {/* Flag per invio email automatizzata */}
          <div className="modal-section">
            <h4>🔔 Notifiche Automatizzate</h4>
            <label>Abilita invio email per scadenza manutenzione:</label>
            <input
              type="checkbox"
              checked={invio_email_scadenza || false}
              onChange={(e) => setClienteData({ ...cliente, invio_email_scadenza: e.target.checked })}
            />
          </div>

          {/* Pulsanti con icone */}
          <div className="modal-buttons">
            <button onClick={onSave} className="btn save-btn">
              <FaSave style={{ marginRight: "6px" }} />
              {cliente.id ? "Salva Modifiche" : "Crea Cliente"}
            </button>
            <button onClick={onClose} className="btn cancel-btn">
              <FaTimes style={{ marginRight: "6px" }} />
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClienteModal;